/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ec68f50b66e1691fe8a38625dcb5620>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AiChatIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.17.1zm-3.5 2H0a.75.75 0 0 0 1.12.65zM2.63 2h10.75V.5H2.63zM14.5 3.13v8.25H16V3.13zm-1.12 9.37H4.25V14h9.13zm-9.5.1-3.5 2 .74 1.3 3.5-2zM1.5 15.25V3.13H0v12.12zm13-3.87c0 .62-.5 1.13-1.12 1.13V14A2.63 2.63 0 0 0 16 11.38zM13.38 2c.62 0 1.13.5 1.13 1.13H16A2.63 2.63 0 0 0 13.38.5zM2.63.5A2.63 2.63 0 0 0 0 3.13h1.5C1.5 2.5 2 2 2.63 2zM6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AiChatIcon.displayName = 'AiChatIcon';
var _default = exports.default = AiChatIcon;